module.exports = __webpack_public_path__ + "media/styles/images/svg/circle-ex-red-dark-on-white-07b586a453dceb8e42d87174ec701b5a.svg";